<script setup lang="ts">
const { runAction } = useSmarticoInit();

const { isReadySmartico } = storeToRefs(useSmarticoInit());

const { gamificationActiveAndShow, isGamificationNativeActived } =
  storeToRefs(useSmarticoConfigs());

onMounted(async () => {
  if (gamificationActiveAndShow.value) {
    await navigateTo(localeLink('/vip/tournaments'));
  } else if (isGamificationNativeActived.value) {
    if (isReadySmartico.value) {
      runAction('dp:gf');
      await navigateTo(localeLink('/'));
    }
  }
});

watch(
  () => isReadySmartico.value,
  () => {
    if (isGamificationNativeActived.value && isReadySmartico.value) {
      runAction('dp:gf');
      navigateTo(localeLink('/'));
    }
  },
);
</script>

<template>
  <div :class="$style.centerPage">
    <SmarticoAlertsAndLoader />
  </div>
</template>

<style module lang="postcss">
.centerPage {
  @apply w-full min-h-[600px] flex justify-center relative;
}
</style>
